import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ReportCustomerVoucherMain from "../../../features/report/report-customer-voucher/component/ReportCustomerVoucherMain";

const title = "Report Customer Voucher";

const ReportCustomerVoucherPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <ReportCustomerVoucherMain />;
};

export default ReportCustomerVoucherPage;
